import * as React from 'react';

import { IAuthService } from '../../services/Interfaces/IAuthService';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { AppActionCreators, ApplicationState, AppState } from '../../store';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { ScaleLoader } from 'react-spinners';
import { Button, Grid, IconButton, List, ListItem } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import CheckIcon from '@material-ui/icons/Check';
import { IAppUserService } from '../../services/Interfaces/IAppUserService';
import { CaseComment, NotificationProps, UserNotificationProps } from '../../interfaces/Case';
import moment from 'moment';
import { Card } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserNotification } from '../../interfaces/UserNotificationsUpdate';



// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICaseMessageNotificationState {}

class CaseMessageNotificationItemForPopUp extends React.PureComponent<
  UserNotificationProps,
  ICaseMessageNotificationState
> {
  private authService!: IAuthService;
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appUserService!: IAppUserService;

  static contextType = ApplicationContext;

  state = {} as ICaseMessageNotificationState;

  onClick = async (notificationId: number, caseId: number) => {
    try {
      await this.handleCheck(notificationId);
      
      const currentPath = this.props.history.location.pathname.toLowerCase();
      this.props.history.push('/cases/' + caseId);

      if (currentPath.indexOf('/cases/') !== -1) {
        this.props.history.go(0);
      }
      if (this.props.onClick !== undefined) {
        this.props.onClick();
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleCheck = async (notificationId: number) => {
    try {
      await this.caseService.ReadUserNotification(notificationId);
      await this.caseService.DeleteUserNotification(notificationId);
      this.props.RemoveNotification(notificationId);
    } catch (ex) {
      console.log(ex);
    }
  };
  
  public render() {
    this.authService = (this.context as AppContext).authenticationService;
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appUserService = (this.context as AppContext).appUserService;

	const index = this.props.index;
    const item = this.props.item.entity as UserNotification;

    return (
      <React.Fragment>
        <Grid container spacing={1}>
            <Grid item xs={1}>
              <div
                className={`p-0 ${!item.read ? 'font-weight-bold' : ''}`}
              >
                {index + 1}
              </div>
            </Grid>

            <Grid item xs={3}>
                <Button
                color="primary"
                className="text-primary justify-content-start p-0"
                onClick={(e) => this.onClick(item.id, item.details.caseId)}
                >
                {item.details.caseId}
                </Button>
                <div>{item.details.statusDisplayName}</div>
            </Grid>

            <Grid item xs={4}>
                <div>
                {isNullOrUndefined(item.details.userName)
                          ? ''
                          : item.details.userName +
                            ' (' +
                            item.details.userHoName +
                            ')'}
                </div>
                <div className="font-size-sm text-black-50">
                {moment
                    .utc(item.dateCreation)
                    .local()
                    .format(this.props.appState.longDateFormat)}
                </div>
            </Grid>
            
            <Grid item xs={3}>
                <div className="font-size-sm text-black-50">
                {item.details.text}
                </div>
            </Grid>
            
            <Grid item container direction="column" xs={1}>
                <IconButton
                size="small"
                onClick={(e) => {
                    this.handleCheck(item.id);
                }}
                >
                <CheckIcon fontSize="small"></CheckIcon>
                </IconButton>
            </Grid>
            
        </Grid>
      </React.Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: NotificationProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});

export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  AppActionCreators,
  mergeProps
)(withRouter(CaseMessageNotificationItemForPopUp as any));
